import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { ScrollIntoView, Alert, Loader, Button } from '@grandvisionhq/common';
import { Text, Heading } from '@grandvisionhq/elements';
import CategoryGroup from '../../../Profile/components/CategoryGroup/CategoryGroup.js';
import OrderListItemContainer from '../OrderListItem/OrderListItemContainer.js';

const OrderList = ({ error , labels , loading , orders , ordersLoaded , totalOrders , onLoadMoreClick , onContactLinkClick ,  })=>{
    const contactElement = labels.contactText ? /*#__PURE__*/ React__default.createElement(Text, {
        onClick: onContactLinkClick
    }, labels.contactText) : null;
    if (error) {
        return /*#__PURE__*/ React__default.createElement(ScrollIntoView, null, /*#__PURE__*/ React__default.createElement(Alert, {
            type: "error",
            icon: "alert-circle"
        }, labels.error));
    }
    if (!orders) {
        return /*#__PURE__*/ React__default.createElement(Loader, null);
    }
    if (totalOrders < 1 && !loading) {
        return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Text, null, labels.noHistory), contactElement, /*#__PURE__*/ React__default.createElement(Heading, {
            component: "h4",
            variant: "smallest"
        }, labels.productCategories), /*#__PURE__*/ React__default.createElement(CategoryGroup, null));
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "order-list"
    }, contactElement, orders.map((order)=>/*#__PURE__*/ React__default.createElement(OrderListItemContainer, swcHelpers.extends({}, order, {
            key: order.orderNumber
        }))
    ), totalOrders < 1 && loading ? /*#__PURE__*/ React__default.createElement(Loader, null) : /*#__PURE__*/ React__default.createElement("div", {
        className: "order-list__pager"
    }, /*#__PURE__*/ React__default.createElement(Text, {
        className: "order-list__pager-label"
    }, labels.progressLabel), ordersLoaded < totalOrders && /*#__PURE__*/ React__default.createElement(Button, {
        "data-t": "load-more",
        className: "order-list__pager-button",
        caption: labels.loadMore,
        onClick: onLoadMoreClick,
        isLoading: loading,
        variant: "outline",
        size: "small"
    })));
};
var OrderList$1 = OrderList;

export { OrderList$1 as default };
//# sourceMappingURL=OrderList.js.map
